<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.NOTIFY_ALL_ACCOUNT_USERS_HELP_TEXT' | translate }}
  </div>
  <automata-send-notification-form
    #notificationForm
    [partnerId]="automation.namespace"
    [step]="step"
    [defaultLinkTemplate]="defaultLinkTemplate$ | async"
    [userTypeKey]="'AUTOMATIONS.EDITOR.TASKS.SEND_NOTIFICATIONS.USER_TYPES.USERS'"
  ></automata-send-notification-form>
</div>
